import * as React from 'react';
import * as VerifyDeviceActions from 'user/VerifyDeviceActions';
// @ts-ignore
import { ConfirmableDeviceType } from 'entities/Device';
import { SendType } from 'user/components/LinkDeviceVerificationCodeBox';
import LinkDeviceVerificationCodeBox from 'user/components/LinkDeviceVerificationCodeBox';

export type Props = {
  sendType: SendType;
  deviceAddress: string;
  deviceType: ConfirmableDeviceType;
  footer?: React.ReactNode;
  skipUpdateDevicePreferences?: boolean;
  onResend: () => void;
  onDeviceVerified: () => void;
  onDeviceExists: (claimToken: string) => void;
};

export default class VerifyDeviceCodeContainer extends React.Component<Props, {}> {
  verifyDeviceCode = async (code: string) => {
    const resp = await VerifyDeviceActions.verifyDeviceCode(this.props.deviceAddress, code);

    if (resp) {
      const { verifyDeviceForAccountMerge } = resp;

      if (verifyDeviceForAccountMerge.__typename === 'Device') {
        this.props.onDeviceVerified();
      } else {
        this.props.onDeviceExists(verifyDeviceForAccountMerge.token);
      }
    }
  };

  render() {
    return (
      <LinkDeviceVerificationCodeBox
        skipUpdateDevicePreferences={this.props.skipUpdateDevicePreferences}
        onSubmit={this.verifyDeviceCode}
        submittedAddress={this.props.deviceAddress}
        onResend={this.props.onResend}
        footer={this.props.footer}
        deviceType={this.props.deviceType}
        sendType={this.props.sendType}
      />
    );
  }
}
